import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  IIntegration,
  PlatformIntegrationEnum,
} from '../types/integrationType';

interface PlatformIntegration {
  [PlatformIntegrationEnum.GOOGLE_TAG_MANAGER]: IIntegration;
  [PlatformIntegrationEnum.FACEBOOK_CONVERSATION]: IIntegration;
}

const initialState: PlatformIntegration = {
  [PlatformIntegrationEnum.GOOGLE_TAG_MANAGER]: {
    platform: PlatformIntegrationEnum.GOOGLE_TAG_MANAGER,
    integrationId: '',
    events: [],
  },
  [PlatformIntegrationEnum.FACEBOOK_CONVERSATION]: {
    platform: PlatformIntegrationEnum.FACEBOOK_CONVERSATION,
    integrationId: '',
    events: [],
  },
};
const platformIntegrationSlice = createSlice({
  name: 'platformIntegration',
  initialState,
  reducers: {
    setPlatformIntegration: (
      state,
      action: PayloadAction<PlatformIntegration>,
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setPlatformIntegration } = platformIntegrationSlice.actions;
export default platformIntegrationSlice.reducer;
